import React, { useCallback } from 'react'
import { hooks } from '@front/volcanion'

import Callbacks from './callbacks'
import IdentifierPinCallbacks from './IdentifierPinForm/callbacks'
import NotifyDriversCallbacks from './NotifyDrivers/callbacks'

const withContainer = Component => props => {
  const { openNotification } = hooks.useNotification()
  const [{ record_id, ridemode_validation }, setFormState] = hooks.useFormState()
  const requestSubmit = hooks.useFormFunction('requestSubmit')

  const new_ridemode_id = ridemode_validation?.context?.data?.ridemode
  const setFormValues = hooks.useFormChange()

  const [order] = hooks.useModel('order', [record_id], { single: true, populate: ['assigned_transport.driver.info'] })
  const [, searchUser] = hooks.useModelSearch('user', 'get', { single: true, populate: ['auth'] })
  const [createComment] = hooks.useModelFunction('comment', 'generate')
  const [dispatchJob] = hooks.useModelFunction('job', 'dispatch')
  const [sendDriverMessage] = hooks.useModelFunction('broadcast', 'generate')

  const job_id = _.get(order, 'job')
  const driver_id = _.get(order, 'assigned_transport.driver.user_id')

  const onCloseScheduleInformation = () => setFormState({ unauthorized_schedule: false })
  const onCloseTrafficAlertInformation = () => setFormState({ traffic_alert: false })

  const handleSendComment = useCallback(Callbacks.handleSendCommentHandler(createComment, record_id, openNotification), [createComment, record_id, openNotification])
  const handleManualDispatch = useCallback(Callbacks.handleManualDispatchHandler(dispatchJob, record_id, openNotification), [dispatchJob, record_id, openNotification])
  const handleBeforeManualDispatch = useCallback(Callbacks.handleBeforeManualDispatchHandler(openNotification), [openNotification])
  const handleSendMessageDriver = useCallback(Callbacks.handleSendMessageDriverHandler(sendDriverMessage, driver_id, openNotification), [sendDriverMessage, driver_id, openNotification])
  const handleRedispatch = useCallback(Callbacks.handleRedispatchHandler(dispatchJob, job_id, record_id, openNotification), [dispatchJob, job_id, record_id, openNotification])
  const handleConfirmOptions = useCallback(() => requestSubmit({ force_options: true }), [requestSubmit])
  const handleNotifyDrivers = useCallback(NotifyDriversCallbacks.handleNotifyDriversHandler(sendDriverMessage), [sendDriverMessage])
  const getNotifyDriversFailedNotification = useCallback(NotifyDriversCallbacks.getNotifyDriversFailedNotificationHandler(), [])
  const notifyDriversRecordToForm = useCallback(NotifyDriversCallbacks.recordToFormHandler(), [])
  const handleConfirmLimitExceeded = useCallback(() => requestSubmit({ force_limit_exceeded: true, force_duplicate_order: true, force_options: true }), [requestSubmit])

  const onSubmitIdentifierPinForm = useCallback(IdentifierPinCallbacks.onSubmitHandler(searchUser, setFormState, setFormValues), [searchUser, setFormState, setFormValues])
  const getFailedNotificationIdentifierPin = useCallback(IdentifierPinCallbacks.getFailedNotificationHandler(), [])
  const onCloseInformationValidation = useCallback(() => {
    setFormValues([{ field: 'ridemode', value: new_ridemode_id }, { field: 'returnAt', value: undefined }])
  }, [setFormValues, new_ridemode_id])

  const mergedProps = {
    record_id,
    onCloseInformationValidation,
    onCloseScheduleInformation,
    onCloseTrafficAlertInformation,
    handleSendComment,
    handleManualDispatch,
    handleBeforeManualDispatch,
    handleSendMessageDriver,
    handleRedispatch,
    handleConfirmOptions,
    onSubmitIdentifierPinForm,
    getFailedNotificationIdentifierPin,
    handleNotifyDrivers,
    getNotifyDriversFailedNotification,
    notifyDriversRecordToForm,
    handleConfirmLimitExceeded
  }

  return <Component {...mergedProps} {...props} />
}

export default withContainer
